<template>
  <teleport to="body">
    <transition name="fade">
      <div v-if="showFullScreenLoading"
        class="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-primary backdrop-blur-md text-white">
        <!-- ReadyChek Logo Container -->
        <div class="flex flex-col items-center animate-logo">
          <div class="flex items-center gap-2 mb-6">
            <!-- SVG Logo Mark -->
            <svg class="w-16 h-16 text-green-400" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
            <!-- <img src="@/assets/2022/ReadyChekAnimatedLoading.gif" width="50px"/> -->
            <!-- Text Mark -->
            <span class="text-4xl font-black tracking-tight text-white">
              Ready<span class="text-green-400">Chek</span><span class="text-indigo-400">.com</span>
            </span>
          </div>

          <!-- Progress Bar UI -->
          <v-progress-linear indeterminate color="white"></v-progress-linear>
          <p class="mt-6 text-sm font-medium text-white uppercase tracking-[0.2em]">Loading your session {{ status }}</p>
          <br />
          <p v-if="showRefresh" class="mt-6 text-sm font-small text-white pb-4">This appears to be taking a long time, press Refresh to try again</p>
          <v-btn v-if="showRefresh" variant="tonal" @click="forceRefresh(company)">Refresh</v-btn>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import { computed, onMounted, watch, ref } from 'vue';
import { useConnection } from '@/v3/composables/useConnection';

const props = defineProps({
  isLoading: { type: Boolean, default: false }
});

const {
  loadingMessage,
  log,
} = useConnection();

const status = ref("");
const showRefresh = ref(false);

const showFullScreenLoading = computed(() => props.isLoading);

function forceRefresh() {
  window.location.reload();
}

watch(loadingMessage, (newVal) => {
  status.value = newVal;
});

onMounted(() => {
  status.value = loadingMessage;
  log.info("Refreshing page");
  setTimeout(() => {
    showRefresh.value = true;
  }, 3000);
});
</script>
